// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1c0Ix","actionsCol":"EnrolledClinics_actionsCol__Jmhfi"};